import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { submissionsApi } from '../../../../utils'
import classes from './LessonViewerTabs.module.css'
import { useNavigate } from 'react-router-dom';
import { throwApiError } from "../../store/error-handling-actions";
import * as PathRouter from '../../../../models/PathRoute'
import { ActivityTypeEnumText } from "../../models/ActivityTypeEnum";
import DynamicMessage from "../../UI/Popups/DynamicMessage/DynamicMessage";
import { DynamicMessageTypeEnum } from "../../models/DynamicMessageTypeEnum";
import { changeActiveLessonId } from "../../../../store/general-actions";
import { SubmissionStateTypeTextEnum } from "../../models/SubmissionStateTypeEnum";

const LessonViewerTabs = ({
    btnList,
    teacherMode,
    data,
    setData,
    ProjectsComm,
    studyGroupId,
    saveProjectCallback,
    setShowReflection,
    shareBtn,
    onlyView,
    handleOpenProject,
    loader,
    currentContentIndex,
    widthAssessmentStyle,
    hundleShowLessonQuestion,
    jumpToQuestion,
    selectedAssessmentId,
    scoreByRetries }) => {

    const texts = useSelector(state => state.translate.texts);
    const homeUrl = useSelector(state => state.application.homeUrl);
    const user = useSelector((state) => state.auth.user);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [message, setMessage] = useState(null)

    const navigateWithState = (url, lessonParticipant) => {
        navigate(`${url}`, { state: { prevPath: window.location.pathname, replace: true, lessonParticipant: lessonParticipant } })
    }

    const submissionChangeStatusAndNavigate = (url, submission) => {
        if (submission.submissionStatus === "NotStarted") {
            const submissionChangeStatusInput = {
                id: submission.id,
                submissionStatus: "Started",
                studyGroupId: studyGroupId,
                lessonId: data.id
            }

            const allUserIds = data?.lessonParticipant?.user?.users?.map(u => u.id !== user.id ? u.id : null).filter(Boolean);
            dispatch(changeActiveLessonId(data.id, studyGroupId, data.name, allUserIds));

            submissionsApi.submissionsChangeStatusPost({ submissionChangeStatusInput }, (error, resdata, response) => {
                if (error) {
                    let userMessage = texts.MessageContentSubmissionsChangeStatus;
                    if (error.status === 403) {
                        userMessage = texts.MessageContentProjectsFilterIdNoPermissions;
                    }
                    if (error?.response?.body?.code == 413) {
                        setMessage(<DynamicMessage
                            type={DynamicMessageTypeEnum.Warn}
                            title={texts.LessonInEditByTeamMember}
                            showCancel={false}
                            confirmText={texts.ok}
                            confirmFunc={() => setMessage(null)} />);
                    }
                    else
                        dispatch(throwApiError({ userMessage, error, statusCode: response?.statusCode, message: "submissionsChangeStatusPost " + error.message, level: 2, component: "LessonViewer", line: 52 }))
                }
                else {
                    navigateWithState(url, data?.lessonParticipant);
                }
            })
        }
        else {
            navigateWithState(url, data?.lessonParticipant);
        }
    }

    const submissionGetProjectAndNavigate = (url, externalId) => {
        const submissionsProjectFilter = {
            lessonId: data.id,
            activityType: externalId ? ActivityTypeEnumText.Learning : ActivityTypeEnumText.Final,
            assessmentExternalId: externalId
        }
        submissionsApi.submissionsFilterProjectPost({ submissionsProjectFilter }, (error, resdata, response) => {
            if (error)
                dispatch(throwApiError({ userMessage: texts.MessageContentSubmissionsFilterRange, error: error, statusCode: response?.statusCode, message: "submissionsFilterProjectPost " + error.message, level: 2, component: "LessonViewerTabs", line: 66 }))
            else {
                if (resdata.id) {
                    navigateWithState(url + resdata.projectId);
                }
                else {
                    const submissionAddInput = {
                        assessmentId: resdata.assessmentId,
                        submissionStatus: SubmissionStateTypeTextEnum.Started,
                        studyGroupId,
                    }

                    const allUserIds = data?.lessonParticipant?.user?.users?.map(u => u.id !== user.id ? u.id : null).filter(Boolean);
                    dispatch(changeActiveLessonId(data.id, studyGroupId, data.name, allUserIds));

                    submissionsApi.submissionsAddPost({ submissionAddInput }, (submissionsError, submissionsResdata, submissionsResponse) => {
                        if (!submissionsError) {
                            navigateWithState(url + submissionsResdata.submission?.project?.id);
                        }
                    })
                }

            }
        })
    }

    function openProject(externalId, submission) {
        if (handleOpenProject) {
            handleOpenProject()
        }
        else {
            const url = teacherMode ? `${homeUrl}/${PathRouter.PROJECT}/` : `${homeUrl}/${studyGroupId}/${PathRouter.PROJECT}/`;
            if (submission) {
                submissionChangeStatusAndNavigate(url + submission.project?.id, submission);
            }
            else {
                submissionGetProjectAndNavigate(url, externalId);
            }
        }
    }

    return (
        <div className={classes.LessonContainer} style={{ width: widthAssessmentStyle }}>
            <div className={classes.LessonOutlet}>
                {(() => {
                    let Content = btnList[currentContentIndex].component;
                    return <Content
                        {...data}
                        selectedAssessmentId={selectedAssessmentId}
                        openProject={openProject}
                        ProjectsComm={ProjectsComm}
                        teacherMode={teacherMode}
                        setShowReflection={setShowReflection}
                        studyGroupId={studyGroupId}
                        saveProjectCallback={saveProjectCallback}
                        shareBtn={shareBtn}
                        onlyView={onlyView}
                        jumpToQuestion={jumpToQuestion}
                        scoreByRetries={scoreByRetries}
                        hundleShowLessonQuestion={hundleShowLessonQuestion}
                        loader={loader} >
                    </Content>
                })()
                }
            </div>
            {message}
        </div>
    )
}

export default LessonViewerTabs;